function withVelocity () {
  return import(/* webpackChunkName: "velocity" */'velocity-animate')
}

export default withVelocity
